/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Button from '../../components/Button';

const propTypes = {
  position: PropTypes.oneOf(['top', 'bottom']),
  clearAction: PropTypes.func.isRequired,
  clearLabel: PropTypes.element.isRequired,
  confirmAction: PropTypes.func.isRequired,
  confirmLabel: PropTypes.element.isRequired,
};

const ActionButtons = ({
  clearAction,
  confirmAction,
  confirmLabel,
  clearLabel,
  position,
}) => (
  <Container position={position}>
    <Button color='grey' onClick={clearAction}>
      {clearLabel}
    </Button>
    <Button id="save-company-dashboard-button" onClick={confirmAction}>
      {confirmLabel}
    </Button>
  </Container>
);

ActionButtons.propTypes = propTypes;

ActionButtons.defaultProps = {
  position: 'bottom',
};

const Container = styled.div`
  background-color: #ffffff;
  bottom: ${props => props.position === 'bottom' ? '0' : 'auto'};
  display: flex;
  left: 0;
  position: fixed;
  right: 0;
  top: ${props => props.position === 'top' ? '0' : 'auto'};
  z-index: 9999;

  & > * {
    flex: 1;
    margin: 6px;
  }
`;

export default ActionButtons;
